// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'babel-polyfill'
import router from './router'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import '../static/css/my-mint.scss'
import tool from './utils/tool'
import Bus from './utils/bus'
import Api from './api/index'
import Fun from './servers/postageMgr'
import Buriedpoint from './servers/buriedpoint'
import Vconsole from 'vconsole'

if (Api.Vconsole) {
	const vConsole = new Vconsole()
	Vue.use(vConsole) // 页面调试
}
Vue.prototype.$tool = tool // 全局方法
Vue.prototype.$bus = Bus // 事件监听
Vue.prototype.$api = Api // Api
Vue.prototype.$fun = Fun // 获取数据方法
Vue.prototype.$Buriedpoint = Buriedpoint // 埋点

Vue.use(MintUI)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js